import React from 'react';
import { Lock } from 'lucide-react';

interface Props {
  count: number;
  couleur: string;
  onUpgrade: () => void;
}

/** Cartes fantômes floutées + overlay CTA pour les utilisateurs gratuits. */
const LockedOffersTeaser: React.FC<Props> = ({ count, couleur, onUpgrade }) => {
  if (count <= 0) return null;

  return (
    <div className="relative mt-1">
      {/* Cartes factices floutées */}
      <div className="flex flex-col gap-2.5 select-none pointer-events-none"
        style={{ filter: 'blur(5px)', opacity: 0.55 }}>
        {[...Array(4)].map((_, i) => (
          <div key={i}
            className="bg-white rounded-2xl border border-gray-100 p-4 flex items-center gap-4">
            {/* Placeholder logo */}
            <div className="w-10 h-10 rounded-xl bg-gray-200 flex-shrink-0" />
            <div className="flex-1 min-w-0 flex flex-col gap-1.5">
              {/* Titre */}
              <div className="h-3.5 rounded-full bg-gray-200"
                style={{ width: `${62 + (i % 3) * 12}%` }} />
              {/* Sous-titre */}
              <div className="h-2.5 rounded-full bg-gray-100"
                style={{ width: `${38 + (i % 4) * 8}%` }} />
              {/* Badge contrat */}
              <div className="h-4 w-16 rounded-full bg-gray-100 mt-0.5" />
            </div>
            {/* Date + actions */}
            <div className="flex items-center gap-2 flex-shrink-0">
              <div className="h-2.5 w-14 rounded-full bg-gray-100" />
              <div className="w-7 h-7 rounded-xl bg-gray-100" />
              <div className="w-7 h-7 rounded-xl bg-gray-100" />
            </div>
          </div>
        ))}
      </div>

      {/* Dégradé de fondu (haut transparent → bas masquant) */}
      <div className="absolute inset-0 pointer-events-none"
        style={{
          background: 'linear-gradient(to bottom, transparent 0%, rgba(255,255,255,0.55) 30%, rgba(255,255,255,0.98) 65%)',
        }} />

      {/* Overlay CTA */}
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
        <div className="rounded-2xl shadow-xl px-6 py-5 flex flex-col items-center text-center max-w-sm w-full"
          style={{ background: `linear-gradient(135deg, ${couleur} 0%, ${couleur}dd 100%)` }}>
          <p className="text-2xl font-black text-white mb-1">
            +{count} offres
          </p>
          <p className="text-white/80 text-xs mb-4 leading-relaxed">
            Ces offres sont réservées aux membres Pro.<br />Ne laissez pas les autres candidats prendre de l'avance.
          </p>
          <button
            onClick={onUpgrade}
            className="pbtn--royal w-full py-3 rounded-xl text-sm font-bold bg-white active:scale-95 transition-all"
            style={{ color: couleur, fontSize: '0.95rem', letterSpacing: '0.01em' }}>
            Passer Pro
          </button>
        </div>
      </div>

      {/* Hauteur minimale pour que le CTA ait de l'espace */}
      <div style={{ height: 40 }} />
    </div>
  );
};

export default LockedOffersTeaser;
